export const headerUnderlineStyle = { textAlign: "center", textDecoration:"underline", textDecorationColor:"#2196F3", textDecorationStyle:"wavy"}
